import {RouterContext} from './context'

type Props = {
  children: any,
  initialProps: any,
  router: any
}

const RouterProvider = ({children, router}: Props) => (
  <RouterContext.Provider value={router}>{children}</RouterContext.Provider>
)

export default RouterProvider
